<template>
  <div>
    <h5>Esqueci minha senha</h5>
    <form @submit.prevent="submit">
      <input v-model="email" type="email" required placeholder="Seu e-mail" />
      <button type="submit">Enviar instruções</button>
    </form>
    <p v-if="message">{{ message }}</p>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import axios from '@/services/axios';

const email = ref('');
const message = ref('');

async function submit() {
  const res = await axios.post('/auth/forgot-password', { email: email.value });
  message.value = res.data.message;
}
</script>
